/**
 * Users Reducers Index
 * Combines all user-related reducers
 */

import { combineReducers } from 'redux';
import usersListReducer from './usersList';
import currentUserReducer from './currentUser';

const usersReducers = combineReducers({
  usersList: usersListReducer,
  currentUser: currentUserReducer
});

export default usersReducers;